module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/bridge_image_02-b3540ed98077dd5c281180e8641dd88c.png";